// extracted by mini-css-extract-plugin
export const header = "header-module--header--2aPJM";
export const scroll = "header-module--scroll--1LI19";
export const inner = "header-module--inner--2LAEY";
export const linkHome = "header-module--link-home--26QxD";